/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

export default {
  SSO_ENABLED: false,
  SSO_LOGIN: '/login/Shibboleth', // or '/saml/login'
  LOGOUT_REDIRECTION: '/',
  TOKEN_AUTH_ENDPOINT: '/login/loginWithToken',
  TOKEN_AUTH_REDIRECT: '/',
  STOP_PREVIEW_KEYWORD: 'STOP_PREVIEW',
  DIGITAL_ZOOM_INCREMENT: 2,
  // features switches
  APPENGINE_ENABLED: false,
  PRELOADED_SLICES: 50,
  // features switches
  ALGORITHMS_ENABLED: false,  // set to false by default while we do not have an AppEngine
  MAX_MERGEABLE_CHANNELS: 36,
  // Refresh intervals (expressed in milliseconds)
  VIEWER_ANNOTATIONS_REFRESH_INTERVAL: 10000,
  MEMBERS_ACTIVITY_REFRESH_INTERVAL: 30000,
  PING_INTERVAL: 20000, // should be lower than 30 seconds (otherwise, not counted in backend)
  TASK_REFRESH_INTERVAL: 2000,
  STORAGE_REFRESH_INTERVAL: 10000,
  ONGOING_UPLOAD_REFRESH_INTERVAL: 500,
  SAVE_POSITION_IN_IMAGE_INTERVAL: 5000, // position also stored each time the user moves in the image
  BROADCASTING_USERS_REFRESH_INTERVAL: 10000,
  TRACKING_REFRESH_INTERVAL: 500,
  HISTOGRAM_REFRESH_INTERVAL: 3000,
  ANNOTATION_STROKE_COLOR:  [0, 0, 0, 1],
  ANNOTATION_STROKE_SELECT_COLOR: [0, 153, 255, 1],
  ANNOTATION_STROKE_OPACITY: 1,
  DEFAULT_OPACITY: 0.1,
  MAX_IMAGES_FOR_FILTER: 50000,
  // ---
  IDLE_DURATION: 120, // if the user does not move his mouse on the page during this duration, he is considered as inactive - no more ping (expressed in seconds)
  CONFIG_KEY_WELCOME: 'WELCOME',
  PREFIX_HIDDEN_PROPERTY_KEY: '@',
  DEFAULT_PROPERTY_KEY: '@DEFAULT_PROPERTY',
  DEFAULT_IMAGE_CONTROLS_STEP: 2,
  CATEGORY_ITEMS_PER_BATCH: 10,
  ANNOTATIONS_MAX_ITEMS_PER_CATEGORY: 10,
  PROPERTY_FONTSIZE:12,
  PROPERTY_OFFSET_X:0,

  CONFIG_KEY_SHARE_ANNOTATION_EMAIL_MODE: 'SHARED_ANNOTATION_EMAIL_MODE',
  CONFIG_KEY_DELETE_PROJECT_AFTER_DELAY_IN_DAYS: 'DELETE_PROJECT_AFTER_DELAY_IN_DAYS',
  CONFIG_KEY_ACTIVITIES_RETENTION_DELAY_IN_HOURS: 'ACTIVITIES_RETENTION_DELAY_IN_HOURS',
  CONFIG_KEY_COLOR_TOP_MENU: 'COLOR_TOP_MENU',
  CONFIG_KEY_FONT_COLOR_TOP_MENU: 'COLOR_FONT_TOP_MENU',
  CONFIG_KEY_LOGO_TOP_MENU: 'LOGO_TOP_MENU',
  CONFIG_KEY_LTI_CONSUMERS: 'LTI_CONSUMERS',
  CONFIG_KEY_LOGIN_WELCOME: 'LOGIN_WELCOME',
  CONFIG_KEY_DEMO_ACCOUNT: 'DEMO_ACCOUNT',

  CONFIG_KEY_LDAP_SERVER: 'LDAP_SERVER',
  CONFIG_KEY_LDAP_PRINCIPAL: 'LDAP_PRINCIPAL',
  CONFIG_KEY_LDAP_PASSWORD: 'LDAP_PASSWORD',
  CONFIG_KEY_LDAP_SEARCH: 'LDAP_SEARCH',
  CONFIG_KEY_LDAP_ATTRIBUTES: 'LDAP_ATTRIBUTES',
  CONFIG_KEY_LDAP_USERNAME_ATTRIBUTE_NAME: 'LDAP_USERNAME_ATTRIBUTE_NAME',
  CONFIG_KEY_LDAP_EMAIL_ATTRIBUTE_NAME: 'LDAP_EMAIL_ATTRIBUTE_NAME',
  CONFIG_KEY_LDAP_FIRSTNAME_ATTRIBUTE_NAME: 'LDAP_FIRSTNAME_ATTRIBUTE_NAME',
  CONFIG_KEY_LDAP_LASTNAME_ATTRIBUTE_NAME: 'LDAP_LASTNAME_ATTRIBUTE_NAME',
  // To keep the WebSockets alive by sending the broadcaster viewer position
  WS_POSITION_KEEP_ALIVE_INTERVAL: 10000,

  PROJECT_ACTIVITY_ONLY_ADMIN: false,
  HLC_VERSION: null,

  SAMANTREE_WEBSITE: 'https://www.samantree.com',
  SAMANTREE_CONTACT_EMAIL: 'info@samantree.com',
  COMPANY_NAME: 'SamanTree Medical',
  PRODUCT_NAME: 'Histolog® Connect',

  // Resolution (zoom) constraints for some image formats.
  // Expressed in image's pixel per viewer pixel. Example: Resolution=2 -> Zoom = 1/2 (50%).
  // Take precedence over all other zoom configurations.
  RESOLUTION_CONSTRAINTS: {
    ACQUIRE: [25, 16, 8, 4, 2, 1, 2/3, 1/2, 1/3, 1/4],
    PREVIEW: [4, 2, 1, 2/3, 1/2, 1/3, 1/4]
  },

  AUTO_ADJUST_SATURATED: 0.5
};
